import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import PropTypes from 'prop-types';
import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

const NoPreview = ({errorSize = 'small', ...props}) => {
  const {t} = useTranslation();
  const variant = errorSize === 'large' ? 'h4' : 'body2';
  const fontSize = errorSize === 'large' ? 48 : '';

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      fontWeight="fontWeightRegular"
      fontSize={`${variant}.fontSize`}
      {...props}
    >
      <Box marginBottom={0.5}>
        <BrokenImageIcon fontSize="large" color="action" style={{fontSize}} />
      </Box>
      <Typography variant="inherit" color="textSecondary" align="center">
        {t('common:thumbnailNoPreview')}
      </Typography>
    </Box>
  );
};
NoPreview.propTypes = {
  errorSize: PropTypes.string,
};

export default NoPreview;
